import React from "react";
import editicon from "../../Images/editicon.png";
import { useState } from "react";
import Editaboutbmlmodal from "../../Modal/Editaboutbmlmodal";
import { useSelector } from "react-redux";

const MyPageAboutUs = ({ data, updateForm, setIsUpdate }) => {
  const { UserProfileID } = useSelector((state) => state.app);
  const [aboyteditclickmodal, setAboyteditclickmodal] = useState(false);
  const [services, setServices] = useState(data?.businessProductCat || []);
  const aboyteditclick = () => {
    setAboyteditclickmodal(!aboyteditclickmodal);
  };

  return (
    <>
      <div className="uploadbannerblmdiv">
        <div className="uploadbannerdivnewmain">
          <div className="consttactdetatlsarroedyrdiv">
            <p className="cinnattddttdtsttspo">About Us</p>
            {
              UserProfileID?._id === data?._id &&
              <div className="editeiconimg" onClick={aboyteditclick}>
                <img src={editicon} alt="..." />
              </div>
            }

          </div>
          <div className="abttsrtxtdivvnappadin">
            <p className="abttsbttetxtttpp">{data?.aboutBusiness || ""}</p>
          </div>
        </div>
      </div>
      {aboyteditclickmodal && (
        <Editaboutbmlmodal
          fdata={data}
          updateForm={updateForm}
          closemodal={setAboyteditclickmodal}
          setIsUpdate={setIsUpdate}
        />
      )}
    </>
  );
};

export default MyPageAboutUs;
